import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTER_BASENAME, isAdminPath } from "@/lib/basePath";

/**
 * The admin lives at the root "/admin" on every host; "/v2/admin" is retired.
 * The /v2 build's server already 302s a direct "/v2/admin…" request to "/admin…",
 * but in-app navigation inside the /v2 SPA (e.g. /v2/login → navigate("/admin"))
 * never reaches the server — the router would keep the user on "/v2/admin…". This
 * hard-navigates (no router) to the root admin instead, keeping query + hash so
 * hand-off tokens and `?after=` survive. Same origin, so the Cognito session in
 * localStorage carries over. No-op in the root build (basename "/").
 */
const AdminBaseEscape = () => {
  const { pathname, search, hash } = useLocation();
  const leave = ROUTER_BASENAME !== "/" && isAdminPath(pathname);

  useEffect(() => {
    if (leave) window.location.replace(pathname + search + hash);
  }, [leave, pathname, search, hash]);

  return null;
};

export default AdminBaseEscape;
